<template>
  <div>
    <div class="text-body-1 mt-10 mb-5 text-black">
      Your business information
    </div>
    <v-form ref="addEditContactsAndSocialsForm">
      <!--Start: Contact details-->

      <v-card flat class="grey lighten-4">
        <v-card-text>
          <!--Start: Buisness name-->
          <v-list-item class="px-0">
            <v-list-item-icon>
              <v-icon class="px-0">
                mdi-briefcase-outline
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title> Business name</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-text-field
            background-color="white"
            dense
            outlined
            v-model="transientLinkInBio.businessName"
            :rules="requiredRules"
          >
          </v-text-field>
          <!--End: Buisness name-->

          <!--Start: City town-->
          <v-list-item class="px-0">
            <v-list-item-icon>
              <v-icon class="px-0">
                mdi-flag-variant-outline
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>City/Town</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-text-field
            background-color="white
        "
            dense
            outlined
            v-model="transientLinkInBio.city"
          >
          </v-text-field>
          <!--End: City town-->

          <!--Start: Country-->
          <v-list-item class="px-0">
            <v-list-item-icon>
              <v-icon>
                mdi-flag-variant-outline
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Country</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-autocomplete
            v-model="transientLinkInBio.country"
            background-color="white"
            outlined
            dense
            :items="telephoneCodes"
            item-text="name"
            item-value="name"
            :rules="requiredRules"
          >
          </v-autocomplete>
          <!--End: Country-->

          <!--Start: Pappyon Card Link-->
          <v-list-item class="px-0">
            <v-list-item-icon color="transparent">
              <v-img class="px-0" src="@/assets/pappyon-icon.png" width="25" height="25" contain />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Pappyon card link</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch v-model="transientLinkInBio.hasPappyonCardLink"></v-switch>
            </v-list-item-action>
          </v-list-item>
          <v-slide-y-transition v-if="transientLinkInBio.hasPappyonCardLink">
            <v-text-field
              background-color="white"
              dense
              outlined
              v-model="transientLinkInBio.pappyonCardLink"
              :rules="requiredRules"
              placeholder="your card url"
              :hint="`e.g. ${urlPrefixes.urlPrefix}www.pappyon.com`"
            >
              <template v-slot:prepend-inner>
                <div class="ml-1 mr-n1 mt-1">{{ urlPrefixes.urlPrefix }}</div>
              </template>
            </v-text-field>
          </v-slide-y-transition>
          <!--End: Pappyon Card Link-->

          <!--Start: General phone number-->
          <v-list-item class="px-0">
            <v-list-item-icon>
              <v-icon>
                mdi-phone-outline
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>General phone number</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch v-model="transientLinkInBio.hasPhoneNumber"></v-switch>
            </v-list-item-action>
          </v-list-item>

          <v-slide-y-transition v-if="transientLinkInBio.hasPhoneNumber">
            <!-- <v-text-field
              background-color="white"
              :rules="requiredRules"
              v-model="transientLinkInBio.phoneNumber"
              dense
              outlined
              :autofocus="transientLinkInBio.hasPhoneNumber && transientLinkInBio.phoneNumber == ''"
            >
            </v-text-field> -->

            <ContactNumber
              backgroundColor="white"
              v-model="transientLinkInBio.phoneNumber"
              :autofocus="transientLinkInBio.hasPhoneNumber && transientLinkInBio.phoneNumber == ''"
            />

            <!-- <v-text-field
              background-color="white"
              :rules="requiredRules"
              v-model="transientLinkInBio.phoneNumber"
              dense
              outlined
              :autofocus="transientLinkInBio.hasPhoneNumber && transientLinkInBio.phoneNumber == ''"
            >
            </v-text-field> -->
          </v-slide-y-transition>
          <!--End: General phone number-->

          <!--Start: General email-->
          <v-list-item class="px-0">
            <v-list-item-icon>
              <v-icon class="px-0">
                mdi-email-outline
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>General email</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch v-model="transientLinkInBio.hasEmail"></v-switch>
            </v-list-item-action>
          </v-list-item>

          <v-slide-y-transition v-if="transientLinkInBio.hasEmail">
            <v-text-field
              :rules="emailRules"
              background-color="white"
              v-model="transientLinkInBio.email"
              dense
              outlined
              validate-on-blur
              :autofocus="transientLinkInBio.hasEmail && transientLinkInBio.email == ''"
            >
            </v-text-field>
          </v-slide-y-transition>
          <!--End: General email-->
        </v-card-text>
      </v-card>
      <!--End: Contact details-->

      <div class="text-body-1 mt-10 mb-5 text-black">
        Your business socials
      </div>

      <!--Start: Business socials-->
      <v-card flat class="grey lighten-4">
        <v-card-text>
          <!--Start: Website-->
          <v-list-item class="px-0">
            <v-list-item-icon>
              <v-img src="@/assets/website-icon.svg" height="25" width="25" contain class="px-0" />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Website</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch v-model="transientLinkInBio.hasWebsite"></v-switch>
            </v-list-item-action>
          </v-list-item>
          <v-slide-y-transition v-if="transientLinkInBio.hasWebsite">
            <v-text-field
              :rules="requiredRules"
              background-color="white"
              v-model="transientLinkInBio.website"
              dense
              outlined
              :autofocus="transientLinkInBio.hasWebsite && transientLinkInBio.website == ''"
              :hint="`e.g. ${urlPrefixes.urlPrefix}www.pappyon.com`"
            >
              <template v-slot:prepend-inner>
                <div class="ml-1 mr-n1 mt-1">{{ urlPrefixes.urlPrefix }}</div>
              </template>
            </v-text-field>
          </v-slide-y-transition>
          <!--End: Website-->

          <!--Start: Facebook-->
          <v-list-item class="px-0">
            <v-list-item-icon>
              <v-img src="@/assets/facebook-icon.svg" height="25" width="25" contain class="px-0" />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Facebook</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch v-model="transientLinkInBio.hasFacebook"></v-switch>
            </v-list-item-action>
          </v-list-item>

          <v-slide-y-transition v-if="transientLinkInBio.hasFacebook">
            <v-text-field
              background-color="white
          "
              v-model="transientLinkInBio.facebook"
              dense
              outlined
              :rules="requiredRules"
              :autofocus="transientLinkInBio.hasFacebook && transientLinkInBio.facebook == ''"
              placeholder="yourhandle"
              :hint="`e.g. ${urlPrefixes.facebookUrlPrefix}pappyon`"
            >
              <template v-slot:prepend-inner>
                <div class="ml-1 mr-n1 mt-1">{{ urlPrefixes.facebookUrlPrefix }}</div>
              </template>
            </v-text-field>
          </v-slide-y-transition>
          <!--End: Facebook-->

          <!--Start: Instagram-->
          <v-list-item class="px-0">
            <v-list-item-icon>
              <v-img src="@/assets/instagram-icon.svg" height="25" width="25" contain class="px-0" />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Instagram</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch v-model="transientLinkInBio.hasInstagram"></v-switch>
            </v-list-item-action>
          </v-list-item>

          <v-slide-y-transition v-if="transientLinkInBio.hasInstagram">
            <v-text-field
              background-color="white
          "
              v-model="transientLinkInBio.instagram"
              dense
              outlined
              :rules="requiredRules"
              :autofocus="transientLinkInBio.hasInstagram && transientLinkInBio.instagram == ''"
              placeholder="yourhandle"
              :hint="`e.g. ${urlPrefixes.instagramUrlPrefix}pappyon`"
            >
              <template v-slot:prepend-inner>
                <div class="ml-1 mr-n1 mt-1">{{ urlPrefixes.instagramUrlPrefix }}</div>
              </template>
            </v-text-field>
          </v-slide-y-transition>
          <!--End: Instagram-->

          <!--Start: Linkedin-->
          <v-list-item class="px-0">
            <v-list-item-icon>
              <v-img src="@/assets/linkedin-icon.svg" height="25" width="25" contain class="px-0" />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Linkedin</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch v-model="transientLinkInBio.hasLinkedIn"></v-switch>
            </v-list-item-action>
          </v-list-item>

          <v-slide-y-transition v-if="transientLinkInBio.hasLinkedIn">
            <v-text-field
              :rules="requiredRules"
              background-color="white"
              v-model="transientLinkInBio.linkedIn"
              dense
              outlined
              :autofocus="transientLinkInBio.hasLinkedIn && transientLinkInBio.linkedIn == ''"
              placeholder="yourhandle"
              :hint="`e.g. ${urlPrefixes.linkedinUrlPrefix}pappyon`"
            >
              <template v-slot:prepend-inner>
                <div class="ml-1 mr-n1 mt-1">{{ urlPrefixes.linkedinUrlPrefix }}</div>
              </template>
            </v-text-field>
          </v-slide-y-transition>
          <!--End: Linkedin-->

          <!--Start: Twitter-->
          <v-list-item class="px-0">
            <v-list-item-icon>
              <v-img src="@/assets/twitter-icon.svg" height="25" width="25" contain class="px-0" />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Twitter</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch v-model="transientLinkInBio.hasTwitter"></v-switch>
            </v-list-item-action>
          </v-list-item>

          <v-slide-y-transition v-if="transientLinkInBio.hasTwitter">
            <v-text-field
              background-color="white"
              v-model="transientLinkInBio.twitter"
              dense
              outlined
              :rules="requiredRules"
              :autofocus="transientLinkInBio.hasTwitter && transientLinkInBio.twitter == ''"
              placeholder="yourhandle"
              :hint="`e.g. ${urlPrefixes.twitterUrlPrefix}pappyon`"
            >
              <template v-slot:prepend-inner>
                <div class="ml-1 mr-n1 mt-1">{{ urlPrefixes.twitterUrlPrefix }}</div>
              </template>
            </v-text-field>
          </v-slide-y-transition>
          <!--End: Twitter-->

          <!--Start: Youtube-->
          <v-list-item class="px-0">
            <v-list-item-icon>
              <v-img src="@/assets/youtube-icon.svg" height="25" width="25" contain class="px-0" />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Youtube</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch v-model="transientLinkInBio.hasYoutube"></v-switch>
            </v-list-item-action>
          </v-list-item>

          <v-slide-y-transition v-if="transientLinkInBio.hasYoutube">
            <v-text-field
              background-color="white
          "
              v-model="transientLinkInBio.youtube"
              dense
              outlined
              :rules="requiredRules"
              :hint="`e.g. ${urlPrefixes.youtubeurlPrefix}pappyon`"
              :autofocus="transientLinkInBio.hasYoutube && transientLinkInBio.youtube == ''"
              placeholder="yourhandle"
            >
              <template v-slot:prepend-inner>
                <div class="ml-1 mr-n1 mt-1">{{ urlPrefixes.youtubeurlPrefix }}</div>
              </template>
            </v-text-field>
          </v-slide-y-transition>
          <!--End: Youtube-->

          <!--Start: Podcast-->
          <v-list-item class="px-0">
            <v-list-item-icon>
              <v-img src="@/assets/podcast-icon.svg" height="25" width="25" contain class="px-0" />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Podcast</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch v-model="transientLinkInBio.hasPodcast"></v-switch>
            </v-list-item-action>
          </v-list-item>

          <v-slide-y-transition v-if="transientLinkInBio.hasPodcast">
            <v-text-field
              background-color="white
          "
              v-model="transientLinkInBio.podcast"
              dense
              outlined
              :rules="requiredRules"
              :autofocus="transientLinkInBio.hasPodcast && transientLinkInBio.podcast == ''"
            >
              <template v-slot:prepend-inner>
                <div class="ml-1 mr-n1 mt-1">{{ urlPrefixes.urlPrefix }}</div>
              </template>
            </v-text-field>
          </v-slide-y-transition>
          <!--End: Podcast-->
        </v-card-text>
      </v-card>
    </v-form>
    <!--End: Business socials-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ContactNumber from "@/components/inputs/ContactNumber";

export default {
  components: {
    ContactNumber,
  },
  computed: {
    ...mapGetters(["linkInBio", "telephoneCodes", "businessProfile", "transientLinkInBio", "urlPrefixes"]),
  },
  data() {
    return {
      requiredRules: [(v) => v != "" || "This field is required"],
      emailRules: [
        (v) => !!v || "Please enter your email",
        (v) => /.+@.+\..+/.test(v) || "Please enter a valid email address",
      ],
    };
  },
  watch: {
    "transientLinkInBio.facebook": function(newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.facebookUrlPrefix)) {
        this.transientLinkInBio.facebook = this.transientLinkInBio.facebook.replace(
          this.urlPrefixes.facebookUrlPrefix,
          ""
        );
      }
    },
    "transientLinkInBio.instagram": function(newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.instagramUrlPrefix)) {
        this.transientLinkInBio.instagram = this.transientLinkInBio.instagram.replace(
          this.urlPrefixes.instagramUrlPrefix,
          ""
        );
      }
    },
    "transientLinkInBio.twitter": function(newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.twitterUrlPrefix)) {
        this.transientLinkInBio.twitter = this.transientLinkInBio.twitter.replace(
          this.urlPrefixes.twitterUrlPrefix,
          ""
        );
      }
    },
    "transientLinkInBio.linkedIn": function(newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.linkedinUrlPrefix)) {
        this.transientLinkInBio.linkedIn = this.transientLinkInBio.linkedIn.replace(
          this.urlPrefixes.linkedinUrlPrefix,
          ""
        );
      }
    },
    "transientLinkInBio.website": function(newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.urlPrefix)) {
        this.transientLinkInBio.website = this.transientLinkInBio.website.replace(this.urlPrefixes.urlPrefix, "");
      }
    },
    "transientLinkInBio.podcast": function(newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.urlPrefix)) {
        this.transientLinkInBio.podcast = this.transientLinkInBio.podcast.replace(this.urlPrefixes.urlPrefix, "");
      }
    },
    "transientLinkInBio.pappyonCardLink": function(newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.urlPrefix)) {
        this.transientLinkInBio.pappyonCardLink = this.transientLinkInBio.pappyonCardLink.replace(
          this.urlPrefixes.urlPrefix,
          ""
        );
      }
    },
  },
  methods: {
    validateForm() {
      return this.$refs.addEditContactsAndSocialsForm.validate();
    },
  },
};
</script>

<style></style>
